import { IAction } from '@/redux/actions/action-helpers'
import { MileageRatesTypes } from '@/redux/actions/actions.types'
import { ApplicationState } from '@/redux/stores/types'
import { MileageRate } from '@/types/expenses/mileage'

function mileageRates(state: ApplicationState['mileageRates'] = [], action: IAction) {
	switch (action.type) {
		case MileageRatesTypes.GetRates.SUCCESS:
			return action.payload
		default:
			return state
	}
}

export function denormalizeRate(rate: MileageRate) {
	return {
		id: rate.id,
		amount: rate.amount,
		country_code: rate.country_code,
		name: rate.name,
		is_default: rate.is_default,
		unit_of_length: rate.unit_of_length,
	} as MileageRate
}

export default mileageRates
